import Utils from './utils';
import SelectionManager from './selections';
import Panel from './panels';
import Remote from './remote';
import flash from './flash';
import Comments from '../comments/comments';
import '../../libs/vendor/immersive-reader-sdk.1.2.0.js';
import ImmersiveReaderContentBuilder from './immersiveReader.js';
import { PreviewNodeRenderer, ViewNodeRenderer, TeacherPanelNodeRenderer, unRender } from './reactLoader';

export default class ContentManager {
  constructor(context, remote, options) {
    this.context = context;
    this.remote = remote;
    this.options = options;

    let title = '';
    if (!this.context.type && typeof this.context.id !== 'string') {
      const header = document.body.querySelector('#headerWrapper h1');
      title = header ? header.textContent : '';
    } else if (this.context?.getName) {
      title = this.context.getName();
    }
    this.immersiveReader = new ImmersiveReaderContentBuilder(title);
  }

  waitForContent(panel) {
    const poller = setInterval(() => {
      const el = $('.content-section');
      const retry = 20;
      if (retry && el.length < 1) return;
      clearInterval(poller);
      this.setupLightbox(panel);
    }, 100);
  }

  setupLightbox(modal) {
    modal.content
      .find(
        '.pr2--circlePanelDescription img, .pr2--nodePanelBody img, .lp--activityEditorSection.student .lp--activityEditorSectionHeader .editor-header-row img, .content-section img',
      )
      .on(Utils.interactionEvent, function (ev) {
        let img = ev.target;

        if ($(img).closest('a').length) {
          return;
        }

        let imgContainer = document.createElement('div');
        imgContainer.classList.add('lp--lightBoxImageContainer');
        imgContainer.style.backgroundImage = `url(${img.src})`;

        let container = document.createElement('div');

        let close = document.createElement('a');
        close.classList.add('lp--lightBoxImageClose');
        container.appendChild(close);

        container.appendChild(imgContainer);
        let position = img.getBoundingClientRect();

        container.classList.add('lp--lightBoxImage');

        imgContainer.style.top = position.y + 'px';
        imgContainer.style.left = position.x + 'px';
        imgContainer.style.width = position.width + 'px';
        imgContainer.style.height = position.height + 'px';

        container.style.zIndex = 1000;
        img.classList.add('lp--js-imageDisplayedInLightbox');
        document.body.appendChild(container);

        setTimeout(function () {
          imgContainer.style.left = '5vw';
          imgContainer.style.top = '5vh';
          imgContainer.style.width = '90vw';
          imgContainer.style.height = '90vh';

          if (
            img.naturalWidth < document.documentElement.clientWidth * 0.9 &&
            img.naturalHeight < document.documentElement.clientHeight * 0.9
          ) {
            imgContainer.style.backgroundSize = `${img.naturalWidth}px ${img.naturalHeight}px`;
          }
          container.classList.add('lp--lightBoxImageOpen');
        }, 10);

        $(container).on(Utils.interactionEvent, function () {
          imgContainer.style.top = position.y + 'px';
          imgContainer.style.left = position.x + 'px';
          imgContainer.style.width = position.width + 'px';
          imgContainer.style.height = position.height + 'px';
          container.classList.remove('lp--lightBoxImageOpen');
          let that = $(this);
          that.on(transition_event_name, function () {
            img.classList.remove('lp--js-imageDisplayedInLightbox');
            that.remove();
          });
        });
      });
  }

  deadline_attach() {
    this.deadline_input = this.panel.content.find('.deadline');
    this.deadline_element = this.panel.content.find('.deadline-rep');

    if (this.deadline_input) {
      this.deadline_input.datepicker({
        defaultDate: this.deadline_get(),
        dateFormat: 'yy-mm-dd',
        constrainInput: true,
        onSelect: (date, datepicker) => {
          this.deadline_element.text(date);
        },
      });
      this.deadline_element.on('keypress ' + Utils.tapInteractionEvent + '.deadline', (ev) => {
        this.deadline_input.datepicker('show');
      });
    }
  }

  updateProgress(result) {
    const { initiated_progress, done_progress, completed_progress } = result;
    $(window).trigger('progress.update', {
      initiated_progress,
      done_progress,
      completed_progress,
    });
  }

  setSaveStatus(saveStatus) {
    $('.activity-editor__status').html(i18n.__(saveStatus));
  }

  showErrorMessage(err) {
    $('.activity-editor__button-panel').addClass('error');
    this.setSaveStatus('behavior_save_failed');
    if (err.code === 413) {
      flash(i18n.__('error_payload_too_large'), { ttl: 20000 });
    } else {
      flash(i18n.__('error_behavior_save_failed'));
    }
  }

  deadline_detach() {
    if (this.deadline_input) {
      this.deadline_input.removeClass('hasDatepicker');
      this.deadline_input.datepicker('destroy');
    }
    this.panel.content.off('.deadline');
  }

  deadline_get() {
    if (this.deadline_element) {
      return isNaN(Date.parse(this.deadline_element.text())) == false ? this.deadline_element.text() : undefined;
    }
    return undefined;
  }

  deadline_save(data) {
    if (this.deadline_input) {
      return this.remote
        .put(
          this.context.getId() + '/session/' + this.options.session_id,
          $.extend({ deadline_at: this.deadline_get() }, data),
        )
        .on('noAccess', () => {
          window.location.replace('/learn/' + this.options.session_id);
        })
        .then((behavior_session) => {
          return behavior_session;
        });
    } else {
      return Promise.resolve(false);
    }
  }

  showLoopDescription() {
    this.panel.content.find('.circle-panel-description').removeClass('collapse');
    this.panel.content.find('.collapsed-description-panel').addClass('collapse');
  }

  hideLoopDescription() {
    this.panel.content.find('.circle-panel-description').addClass('collapse');
    this.panel.content.find('.collapsed-description-panel').removeClass('collapse');
  }

  showTeacherPanelContent(show) {
    if (show) {
      $('.content-viewer').addClass('show');
    } else {
      $('.content-viewer').removeClass('show');
    }
  }

  attach(hideDescription) {
    if (this.options.viewer.teacherPanel) {
      this.targetNode = TeacherPanelNodeRenderer.render(this.context.id, this.context.type, this.options, this.panel);
    } else {
      const isPreview = typeof PreviewMode !== 'undefined' && viewer instanceof PreviewMode;
      if (isPreview) {
        this.targetNode = PreviewNodeRenderer.render(this.context.id, this.context.type, this.options, this.panel);
      } else {
        this.targetNode = ViewNodeRenderer.render(this.context.id, this.context.type, this.options, this.panel);
      }
    }

    let that = this;
    const userId = document.body.getAttribute('data-user-uuid');
    const userSessionHideLoopDescriptionKey = `${userId}_${this.options.session_id}_hideLoopDescription`;
    if (hideDescription || window.localStorage.getItem(userSessionHideLoopDescriptionKey) === 'true') {
      this.hideLoopDescription();
    } else {
      this.showLoopDescription();
    }
    const userShowTeacherPanelContentKey = `${userId}_showTeacherPanelContent`;
    if (window.localStorage.getItem(userShowTeacherPanelContentKey) === 'true') {
      this.showTeacherPanelContent(true);
    }

    const toggleFullScreen = () => {
      Panel.currentPanel.content.toggleClass('lp--fullScreenPanel');
      const inFullscreen = Panel.currentPanel.content.hasClass('lp--fullScreenPanel');
      this.options.viewer.inFullscreen = inFullscreen;
      $(document).trigger('panel.fullscreen', { fullscreen: inFullscreen });
    };

    $(document).on('toggleFullScreen', () => {
      toggleFullScreen();
    });

    this.panel.content.find('.lp--js-fullScreen').off('keypress ' + Utils.tapInteractionEvent + '.fs');
    this.panel.content.find('.lp--js-fullScreen').on('keypress ' + Utils.tapInteractionEvent + '.fs', (ev) => {
      ev.target.blur();
      toggleFullScreen();
    });

    this.panel.content.find('.pr2--js-closeBtn').on('keypress ' + Utils.tapInteractionEvent + '.fs', (ev) => {
      this.panel.content.removeClass('lp--fullScreenPanel');
      this.options.viewer.inFullscreen = false;
      $(document).trigger('panel.fullscreen', { fullscreen: false });
    });

    this.panel.content.find('.lp--js-close-panel').on('keypress ' + Utils.tapInteractionEvent + '.fs', (ev) => {
      this.hideLoopDescription();
      window.localStorage.setItem(userSessionHideLoopDescriptionKey, true);
    });

    this.panel.content.find('.panel-navigation.hub').on('keypress', function () {
      $(this).trigger('click');
    });

    this.panel.content
      .find('.collapsed-description-panel')
      .on('keypress ' + Utils.tapInteractionEvent + '.fs', (ev) => {
        this.showLoopDescription();
        window.localStorage.setItem(userSessionHideLoopDescriptionKey, false);
      });

    $(document).on('comment.open', () => {
      this.panel.content.removeClass('lp--fullScreenPanel');
      this.options.viewer.inFullscreen = false;
      $(document).trigger('panel.fullscreen', {
        fullscreen: this.panel.content.hasClass('lp--fullScreenPanel'),
      });
    });

    this.panel.content.find('.lp--js-immersiveReader').on(Utils.tapInteractionEvent + '.immersiveReader', () => {
      openImmersiveReader();
    });

    this.panel.content.find('.ql-formula').attr('aria-label', i18n.__('ariaLabels.formula'));
    this.panel.content.find('.ql-formula').children().attr('aria-hidden', 'true');

    document.addEventListener('open.immersiveReader', (ev) => {
      const text = ev && ev.detail;
      openImmersiveReader({
        title: i18n.__('app_selection'),
        chunks: [{ content: text, mimeType: 'text/html' }],
      });
    });

    const immersiveReaderRemote = new Remote('/integrations/microsoft/fetchImmersiveReaderLaunchParameters');
    const fetchImmersiveReaderLaunchParameters = () => {
      return new Promise((resolve) => {
        immersiveReaderRemote.get('').then((response) => {
          return resolve(response);
        });
      });
    };

    const openImmersiveReader = async (selectedContent = undefined) => {
      const content = selectedContent || this.immersiveReader.getContent();

      let options = {};
      try {
        const [language] = (document.body.dataset.userLocale || document.body.dataset.userBaseLocale || '').split('-');
        if (language) {
          options.uiLang = language;
        }
      } catch (error) {}

      const params = await fetchImmersiveReaderLaunchParameters();
      const { token, subdomain } = params;
      ImmersiveReader.launchAsync(token, subdomain, content, options);
    };

    if (this.options.viewer.supportsCommunication()) {
      window.selectionManager = new SelectionManager();
      window.selectionManager.init({
        viewer: this.options.viewer,
        commentInstance: this.options.viewer.comments,
      });
    }

    this.panel.hideMountPoint(function (e) {
      e.preventDefault();
      if (that.options && that.options.viewer) {
        that.options.viewer
          .verifyDirtyEditContext()
          .then(() => {
            Panel.hide(that.panel);
          })
          .catch(Utils.noop);
      } else {
        Panel.hide(that.panel);
      }
    });
  }

  detach() {
    unRender(this.targetNode);
    if (window.selectionManager) {
      window.selectionManager.detach();
    }
  }

  loadModal() {
    const panelType = this.context.id ? (this.context.type ? Panel.NODE : Panel.HUB) : Panel.CIRCLE;
    this.panel = new Panel(panelType);

    this.panel.eventSource.on('added.panel', () => {
      this.attach();
    });

    this.panel.eventSource.on('didHide.panel', () => {
      this.detach();
    });

    this.waitForContent(this.panel);

    return Promise.resolve(this.panel);
  }

  load() {
    return Promise.resolve();
  }

  openComsContextFor(entity, uuid) {
    $(document).trigger(Comments.EventTriggerName, {
      entity_uuid: uuid,
      entity_type: entity,
    });
  }

  markAcceptedNode(uuid, state) {
    if (window.viewer) {
      const panelNode = $(`.activity-item[data-uuid=${uuid}]`);
      if (state === 'accepted' && !panelNode.hasClass('accepted')) {
        panelNode.addClass('accepted');
        window.viewer.addCheckmarkById(uuid);
      } else {
        panelNode.removeClass('accepted');
        window.viewer.removeCheckmarkById(uuid, state);
      }
    }
  }

  navigateNext(doneProgress) {
    const navigationNext = $('.navigation-arrow--right');
    if (doneProgress === 1 || navigationNext.length === 0) {
      this.panel.hide();
    } else {
      navigationNext.click();
    }
  }
}

ContentManager.Content = {
  Chunk: 0,
  Behavior: 1,
  Node: 2,
  Task: 3,
  Quiz: 4,
  Blog: 5,
  BlogPost: 6,
  Legend: 7,
  Correlation: 8,
  Circle: 9,
  Evaluation: 10,
};
